var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPie = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.25 8c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75A6.75 6.75 0 0 0 8 1.25a.75.75 0 0 0-.75.75v6zm5.946-.75H8.75V2.804a5.25 5.25 0 0 1 4.446 4.446z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.342 3.65a.75.75 0 0 0-.746-1.3 6.678 6.678 0 0 0-1.742 1.438A6.606 6.606 0 0 0 1.76 10.65a6.652 6.652 0 0 0 2.249 2.832 6.725 6.725 0 0 0 6.963.544 6.67 6.67 0 0 0 2.666-2.447.75.75 0 1 0-1.276-.788 5.172 5.172 0 0 1-2.068 1.897 5.224 5.224 0 0 1-5.408-.422 5.152 5.152 0 0 1-1.742-2.194 5.106 5.106 0 0 1 .847-5.306 5.178 5.178 0 0 1 1.35-1.115z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPie);
export default ForwardRef;